import React from 'react';
import { useOverlayContext } from "../../contexts";
import InviteOrEditMemberModal from "../InviteOrEditMemberModal";
export function useInviteMemberModal() {
  const overlayContext = useOverlayContext();
  const openInviteMemberModal = () => overlayContext.showModal({
    content: _ref => {
      let {
        dismissModal
      } = _ref;
      return /*#__PURE__*/React.createElement(InviteOrEditMemberModal, {
        onClose: dismissModal
      });
    }
  });
  return {
    openInviteMemberModal
  };
}